import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  LogoComponent,
  ToggleButtonComponent
} from '@sparbanken-syd/sparbanken-syd-theme'
import {RoleHelper} from '../../services/role-helper'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, LogoComponent, RouterLink, MatIconButton, ToggleButtonComponent]
})
export class HeaderComponent {
  public readonly configService = inject(ConfigService)
  public readonly helper = inject(RoleHelper)
}
